import axios from 'axios';

const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const AUTH_API = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

export const NO_AUTH_API = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

export const handleApiError = (error) => {
  const message = error?.response?.data?.message || 'Щось пішло не так...';
  return { error: message, data: null };
};
